import { render, staticRenderFns } from "./VisaApplication.vue?vue&type=template&id=2d35df5e&"
import script from "./VisaApplication.vue?vue&type=script&lang=js&"
export * from "./VisaApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports